<template>
  <v-dialog :value="open" @click:outside="closeDialog()" scrollable max-width="500">
    <ValidationObserver ref="responsibleFormOs" v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              {{ EditMode ? "Actualizar" : "Crear" }} Responsable
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 570px">
            <v-form>
              <v-row dense>
                <!-- Nombres -->
                <v-col cols="12">
                  <ValidationProvider name="Nombres" rules="required" v-slot="{ errors }">
                    <v-text-field
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Nombre"
                      name="name"
                      type="text"
                      color="blue-grey"
                      v-model="formData.name"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Apellidos -->
                <v-col cols="12">
                  <ValidationProvider name="Apellidos" rules="required" v-slot="{ errors }">
                    <v-text-field
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Apellidos"
                      name="last_name"
                      type="text"
                      color="blue-grey"
                      v-model="formData.last_name"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- DNI -->
                <v-col cols="12">
                  <ValidationProvider name="DNI" rules="required" v-slot="{ errors }">
                    <v-text-field
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="DNI"
                      type="text"
                      name="dni"
                      color="blue-grey"
                      v-model="formData.dni"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Correo -->
                <v-col cols="12">
                  <ValidationProvider name="Correo" rules="required|email" v-slot="{ errors }">
                    <v-text-field
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Correo"
                      type="text"
                      name="email"
                      color="blue-grey"
                      v-model="formData.email"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Telefono -->
                <v-col cols="12">
                  <ValidationProvider name="Telefono" rules="required" v-slot="{ errors }">
                    <v-text-field
                      required
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Telefono"
                      type="text"
                      name="phone"
                      color="blue-grey"
                      v-model="formData.phone"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>

                <!-- Especialidades -->
                <v-col cols="12">
                  <ValidationProvider name="Especialidades" rules="required" v-slot="{ errors }">
                    <v-autocomplete
                      filled
                      rounded
                      multiple
                      :loading="isLoadingSpecialties"
                      class="rounded-small"
                      dense
                      label="Especialidades"
                      :items="specialtiesList"
                      item-text="name"
                      item-value="id"
                      color="blue-grey"
                      v-model="formData.specialties"
                      :error-messages="errors"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>
          <v-hover v-slot:default="{ hover }">
            <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="closeDialog()">Cancelar</v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click.stop="handleSubmit(submitForm)"
            >
              {{ EditMode ? "Guardar" : "Crear" }}
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";

export default {
  components: { vuescroll },
  props: {
    open: {
      type: Boolean,
    },
    editData: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      isLoadingSpecialties: false,
      specialtiesList: [],
      formData: { name: "", last_name: "", phone: "", email: "", dni: "", specialties: [] },
    };
  },

  computed: {
    EditMode() {
      return !!this.editData;
    },
    User() {
      return this.$store.getters["passport/CURRENT_USER"];
    },
  },

  watch: {
    open(val) {
      if (val) {
        this.getSpecialties();
        if (this.editData) {
          const { name, last_name, email, dni, phone, specialties } = this.editData;
          this.formData = { name, last_name, email, dni, phone, specialties: specialties.map(({ id }) => id) };
        }
      } else {
        this.formData = {
          name: "",
          last_name: "",
          dni: "",
          email: "",
          phone: "",
          specialties: [],
        };
      }
    },
  },

  methods: {
    closeDialog(item) {
      this.$emit("dialog:close", item);
      this.$refs.responsibleFormOs.reset();
    },

    async getSpecialties() {
      this.isLoadingSpecialties = true;
      try {
        const { data } = await PbxHttpClient.get("/module_appointment/specialties_select");
        this.specialtiesList = data;
      } catch (error) {
        console.log(error);
      }
      this.isLoadingSpecialties = false;
    },

    async submitForm() {
      this.isLoading = true;
      let savedData;
      try {
        if (this.EditMode) {
          const { id } = this.editData;
          const { data } = await PbxHttpClient.put(`/module_appointment/responsibles/${id}`, this.formData);
          savedData = data;
          this.$snotify.success("Responsable actualizada con exito", "¡Hecho!");
        } else {
          const { data } = await PbxHttpClient.post("/module_appointment/responsibles", this.formData);
          savedData = data;
          this.$snotify.success("Responsable creada con exito", "¡Hecho!");
        }
        this.closeDialog(savedData);
      } catch (err) {
        this.$snotify.error("Hubo un error guardando la Responsable", "¡Error!");
        // console.log("Error in post:", err);
      }
      this.isLoading = false;
    },
  },
};
</script>
